<template>
    <li  v-if="item"
        :class="{ 'has-megamenu': item.children.length, 'mega-menu-open': megaMenuVisible }"
         @mouseenter="item.parameters.hover = true"
         @mouseleave="item.parameters.hover = false"
         :style="{ backgroundColor: (item.parameters && item.parameters.hover) ? item.parameters.background_hover : ''}"
    >
        <a :href="item.value"
           :style="{ fontWeight: (item.parameters && item.parameters.fontweight) ? item.parameters.fontweight : '', color: (item.parameters && item.parameters.color) ? item.parameters.color : '' }"
           class="js-ga-event"
           data-page-area="main_menu"
           data-type="item"
           data-name="category-name"
           :data-text="item.name"
           data-action="href"
           :data-destination-url="item.value"
        >
            {{ item.name }}
        </a>

        <span class="arrow hidden-md-up"
              v-if="item.children && item.children.length"
              @click="handleClick"
              :class="{ active: megaMenuVisible }"
        >
            <img src="/img/icons/menu-arrow.svg" v-svg-inline>
        </span>

        <MegaMenu v-if="item.children.length"
                  :items="item.children"
                  :open="megaMenuVisible"
                  :all-text="allText"
        />
    </li>
</template>

<script>
import { ref, onMounted } from 'vue'
import MegaMenu from './MegaMenu'

export default {

    props: [
        'data',
        'index',
        'allText'
    ],

    components: {
        MegaMenu
    },

    setup(props) {

        const megaMenuVisible = ref(false)
        const item = ref(null)
        // const emitter = inject('emitter')

        onMounted( () => {
            // console.log(props.data)
            item.value = props.data

            if(!item.value.parameters){
                item.value.parameters = {hover: false}
            }
            else{
                Object.assign(item.value.parameters, {hover: false})
            }

        })

        function handleClick() {
            megaMenuVisible.value = !megaMenuVisible.value
            // emitter.emit('megamenu-open', megaMenuVisible.value)
        }

        return {
            handleClick,
            megaMenuVisible,
            item
        }
    }
}
</script>
